import * as Sentry from "@sentry/react";
import { useMemo } from "react";
import { createBrowserRouter } from "react-router-dom";

interface SentryWatcherProps {
  yandexId?: string;
  telegramId?: string;
}

if (__SENTRY_TOKEN__) {
  Sentry.init({
    dsn: __SENTRY_TOKEN__,
    release: __IMAGE_TAG__,
    integrations: [
      // Performance — трассировка запросов, Web Vitals
      Sentry.browserTracingIntegration(),
      // Session Replay — запись экрана пользователя
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracePropagationTargets: [],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
} else console.log("sentry not init - dev mode");

export const useSentry = () => {
  return useMemo(() => {
    return {
      setUser: ({ yandexId, telegramId }: SentryWatcherProps) => {
        if (__SENTRY_TOKEN__)
          Sentry.setUser({ id: `${yandexId}:${telegramId}` });
      },
    };
  }, []);
};

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(
  createBrowserRouter
);
